// #751: いいね（♥）／お気に入り（★）はログイン必須。未ログインのユーザーが押したら
// サインイン導線（サインイン CTA ダイアログ）を開く。全露出面（WorkCard グリッド・
// 各プレイシェル・arcanelab）から同じダイアログを 1 つだけ開くため、状態は useState で
// グローバルに共有し、実体の <SignInActionDialog> は app.vue に 1 度だけマウントする。
export type SignInCtaKind = 'like' | 'favorite'

export function useSignInCta() {
  const isOpen = useState<boolean>('signInCtaOpen', () => false)
  const kind = useState<SignInCtaKind>('signInCtaKind', () => 'like')

  const open = (k: SignInCtaKind) => {
    kind.value = k
    isOpen.value = true
  }

  const close = () => {
    isOpen.value = false
  }

  return { isOpen, kind, open, close }
}
